export default __webpack_public_path__ + "static/media/FedericoCapitani.b6758b1a.jpg";